import { render, staticRenderFns } from "./CustomDamageRowInputs.vue?vue&type=template&id=4bc5f016"
import script from "./CustomDamageRowInputs.vue?vue&type=script&lang=ts"
export * from "./CustomDamageRowInputs.vue?vue&type=script&lang=ts"
import style0 from "./CustomDamageRowInputs.vue?vue&type=style&index=0&id=4bc5f016&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports